<template>
	<div>
        <app-header></app-header>
        <div class="mt-150">
            <v-container fluid grid-list-xl>
                <v-layout row wrap justify-center>
                    <v-flex xs12 md10 lg6 class="col-height-auto">
                        <v-card class="pa-4">
                            <p class="font-2x mt-7">{{$t('userRequest.submitRequest')}}</p>
                            <v-form ref="userRequestForm" v-model="userRequestVaild">
                                <v-select
                                    v-model="userRequestForm.issue"
                                    :label="$t('userRequest.issue')"
                                    :items="issueSelect"
                                    :rules="issueRules"
                                    item-text="label"
                                    item-value="value"
                                    required>
                                </v-select>
                                <v-text-field
                                    v-model="userRequestForm.regEmail"
                                    :label="$t('userRequest.email')"
                                    :rules="regEmailRules"
                                    :hint="$t('userRequest.emailHint')"
                                    clearable required>
                                </v-text-field>
                                <v-text-field
                                    v-model="userRequestForm.subject"
                                    :label="$t('userRequest.subject')"
                                    :rules="subjectRules"
                                    :hint="$t('userRequest.subjectHint')"
                                    counter="50" clearable required>
                                </v-text-field>
                                <v-textarea
                                    v-model="userRequestForm.description"
                                    :label="$t('userRequest.description')"
                                    :rules="descriptionRules"
                                    :hint="$t('userRequest.descriptionHint')"
                                    counter="1000" clearable auto-grow required>
                                </v-textarea>
                                <v-btn class="primary--text" outline :disabled="!userRequestVaild" :loading="userRequestBtnLoading"  @click="submitRequest">
                                    {{$t("common.submit")}}
                                </v-btn>
                            </v-form>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>
	</div>
</template>
<style>

</style>
<script>
	import Vue from 'vue'
    import config from '../../config.js'
    export default {
        data(){
            return{
                //选择框的数组，label为显示的字符，value为给数据库添加的字符代码
                issueSelect: [
                    {label: this.$t('userRequest.issueSelect.account'), value: 'ACCOUNT' },
                    {label: this.$t('userRequest.issueSelect.password'), value: 'PASSWORD' },
                    {label: this.$t('userRequest.issueSelect.googleAuth'), value: '2FA' },
                    {label: this.$t('userRequest.issueSelect.wallet'), value: 'WAllET' },
                    {label: this.$t('userRequest.issueSelect.other'), value: 'OTHER' }
                ],
                //请求验证校验
                userRequestVaild: true,
                //按钮加载中
                userRequestBtnLoading: false,
                //请求实体对象
                userRequestForm: {
                    issue: '',
                    regEmail: '',
                    subject: '',
                    description: ''
                },
                //问题校验规则
                issueRules: [
                    v => !!v || this.$t('userRequest.rules.issue.required')
                ],
                //邮箱校验规则
                regEmailRules: [
                    v => !!v || this.$t('userRequest.rules.regEmail.required'),
                    v => /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/.test(v) || this.$t('userRequest.rules.regEmail.valid')
                ],
                //主题校验规则
                subjectRules: [
                    v => !!v || this.$t('userRequest.rules.subject.required'),
                    v => (v && v.length <= 50) || this.$t('userRequest.rules.subject.valid')
                ],
                //描述校验规则
                descriptionRules: [
                    v => !!v || this.$t('userRequest.rules.description.required'),
                    v => (v && v.length <= 1000) || this.$t('userRequest.rules.description.valid')
                ],
            }
        },
        created(){
            
        },
        mounted(){
            this.loadRegEmail();
        },
        watch:{
            
        },
        methods: {
            //如果用户登录，就加载默认邮箱地址
            loadRegEmail(){
                if(localStorage.getItem('token')){
                    let url = config.baseUrl + "user/open/getRegEmailById?userId=" + this.$store.state.user.id;
                    this.$http.get(url).then(response => {
                        let data = response.data;
                        if (data.resCode == 0) {
                            this.userRequestForm.regEmail = data.result;
                        }
                    });
                }
            },
            //提交请求
            submitRequest(){
                if(this.$refs.userRequestForm.validate()){
                    let url = config.baseUrl + "request/open/submitRequest";
                    this.userRequestBtnLoading = true;
                    this.$http.post(url, this.userRequestForm).then(response => {
                        let data = response.data;
                        this.userRequestBtnLoading = false;
                        if (data.resCode == 0) {
                            //发送通知邮件
                            this.sendNoticeEmail(data.result.userRequestId);
                            //清除表单
                            this.clearUserRequestForm();
                            //发送通知
                            this.$Notice.success({
                                title: this.$t('userRequest.submitSuccessTitle'),
                                duration: 10,
                                desc: this.$t('userRequest.submitSuccessDesc')
                            });
                            //返回主页
                            this.$router.push({name: 'home'});
                        } else if(data.resCode == -1) {
                            //邮箱不存在
                            this.$Message.error({
                                content: this.$t("lostGoogleAuthentication.emailAddressNotExist"),
                                duration: 3
                            });
                        }
                    }, error => {
                        this.userRequestBtnLoading = false;
                    });
                }
            },
            //清除request表单
            clearUserRequestForm(){
                this.$refs.userRequestForm.reset();
            },
            //发送通知邮件
            sendNoticeEmail(userRequestId){
                let url = config.baseUrl + "sendEmail/open/sendSubmitRequestNoticeEmail?userRequestId=" + userRequestId;
                this.$http.get(url).then(response => {
                    
                });
            },
        },
    }
</script>


// WEBPACK FOOTER //
// UserRequest.vue?1ec9989a